@import '~style-sheet-helpers/core';
@import (reference) '../../constants/screen-width-breakpoints.module.less';
@import (reference) '../../constants/spacing.module.less';

.order-details-modal-body {
  display: grid;
  padding: 20px;
  width: 580px;
  line-height: 22px;

  @media @tablet, @mobile {
    width: 100%;
  }

  ul {
    text-align: left;
    list-style: inside;

    .item {
      display: list-item;
      margin-left: 12px;
    }
  }

  .link {
    font-size: 16px;
  }
}

.insurance-modal-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: @space-0 @space-16;

  > button {
    margin-left: 10px;
  }
}
